import React from 'react';
import { Space } from 'antd';
import Input from '@client/components/input/Input';
import Styles from './Styles.module.scss';
import { SearchOutlined } from '@ant-design/icons';
import { Icon } from '@ui/assets/icons/IconWrapper';

const ViewerHeader: React.FC = () => {
    return (
        <div className={Styles.viewerHeader}>
            <Space style={{ width: '25%', justifyContent: 'flex-start' }}>
                <Icon
                    name="Grid"
                    size={20}
                />
            </Space>

            <Input
                placeholder="Search"
                prefix={<SearchOutlined />}
                className={Styles.viewerHeaderSearch}
            />

            <Space style={{ width: '25%', justifyContent: 'flex-end' }}>
                <Icon
                    name="Download"
                    size={20}
                />
            </Space>
        </div>
    );
};

export default ViewerHeader;
